import Vue, {PropType} from 'vue'

export const ISelectStatus = Vue.extend({
    props: {
        value: {
            type: String,
            required: true
        },
        onSelect: {
            type: Function as PropType<(selected: string) => void>,
            required: true
        },
        title: {
            type: String,
            required: false
        }
    }
})